/// <reference types="qtip2" />

import 'imports-loader?define=>false,jQuery=jquery!qtip2';



// WEBPACK FOOTER //
// typescript://../clientlibs/js/bootstrap/load-qtip.ts